<template>
<div ref="modal" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content" :class="'modal-' + size ? size : 'lg'">
      <div class="modal-header p-3 bg-light">
        <slot name="header">
        <h5 class="modal-title">{{ title }}</h5>
        </slot>

        <div class="btn-toolbar">
          <div class="btn-group btn-group-sm"><slot name="modal-toolbar"></slot></div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
      <div class="modal-body">
        <slot></slot>
      </div>
      <div v-if="$slots.footer" class="modal-footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import $ from 'jquery';
export default {
  props: {
    title: String,
    size: String
  },

  mounted() {
    $(this.$refs.modal).on('hidden.bs.modal', (e) => {
      this.$emit('close', e);
    });
    $(this.$refs.modal).on('shown.bs.modal', (e) => {
      this.$emit('open', e);
    });
  },

  methods: {
    open() {
      $(this.$refs.modal).modal('show');
      console.log('dialog opened');
    },

    close() {
      $(this.$refs.modal).modal('hide');
      console.log('dialog closed');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/lib/ui/Modal.vue